export default "__VITE_ASSET__DaOzX1jX__"